module.exports = __webpack_public_path__ + "assets/shape-footer-top.36d3e74a.svg";